import ReactGA from "react-ga";

export const Analytic = {
  initialize: (id) => {
    ReactGA.initialize(id, {
      debug: process.env.NODE_ENV == "development",
      titleCase: false,
    });
  },
  sendEvent: ReactGA.event
};

